(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/single-rows/single-boards.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/single-rows/single-boards.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.SingleBoards = Backbone.Marionette.CollectionView.extend({
    childView: svs.tipset.views.SingleBoard,
    className: 'single-boards js-slider-wrapper slider-wrapper'
  });
})(Backbone, _, svs);

 })(window);